 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activeDeploy~circleprize~flower~museum~shuiyi~springfes":"activeDeploy~circleprize~flower~museum~shuiyi~springfes","activeDeploy":"activeDeploy","ancientOffer~arithmetic~circleprize~flower~guessDifferentDetail-view~museum~shuiyi~springfes~xuejing~3bafbee7":"ancientOffer~arithmetic~circleprize~flower~guessDifferentDetail-view~museum~shuiyi~springfes~xuejing~3bafbee7","arithmetic~springfes":"arithmetic~springfes","springfes":"springfes","circleprize":"circleprize","flower":"flower","museum":"museum","shuiyi":"shuiyi","ancientOffer":"ancientOffer","arithmetic":"arithmetic","demo~xuejinghanlintu":"demo~xuejinghanlintu","xuejinghanlintu":"xuejinghanlintu","guessDifferentDetail-view":"guessDifferentDetail-view","guessDifferentLevel-view~youcai":"guessDifferentLevel-view~youcai","youcai":"youcai","beer-announce":"beer-announce","canvastest":"canvastest","chinajoyticket":"chinajoyticket","collectCards~share":"collectCards~share","collectCards":"collectCards","share":"share","demo":"demo","discountActiveRules":"discountActiveRules","discountDownload":"discountDownload","discountLogin":"discountLogin","giftActiveRules":"giftActiveRules","giftBag":"giftBag","giftDownload":"giftDownload","guessDifferent-view":"guessDifferent-view","guessDifferentHomePage-view":"guessDifferentHomePage-view","guessDifferentLevel-view":"guessDifferentLevel-view","guessDifferentMuseum-view":"guessDifferentMuseum-view","h":"h","julydraw":"julydraw","midActiveRules":"midActiveRules","midFestival":"midFestival","productList":"productList","shuiyihecheng":"shuiyihecheng","vote":"vote","yellowposter":"yellowposter"}[chunkId]||chunkId) + "." + {"activeDeploy~circleprize~flower~museum~shuiyi~springfes":"ec1f480d","activeDeploy":"ab0d6ff0","ancientOffer~arithmetic~circleprize~flower~guessDifferentDetail-view~museum~shuiyi~springfes~xuejing~3bafbee7":"04937afd","arithmetic~springfes":"f61665ad","springfes":"2a14cb5d","circleprize":"69f2d0f2","flower":"0a8a4246","museum":"93b64f6d","shuiyi":"5efb33b7","ancientOffer":"398ef7fa","arithmetic":"af9058e3","demo~xuejinghanlintu":"56041fd5","xuejinghanlintu":"1eb1e750","guessDifferentDetail-view":"71fa1828","guessDifferentLevel-view~youcai":"dde42b8a","youcai":"b249cf0d","beer-announce":"b321c022","canvastest":"3355a214","chinajoyticket":"98a413c6","collectCards~share":"5fabecb7","collectCards":"1d8a1522","share":"3ddfcc28","demo":"d9acc19b","discountActiveRules":"c3ea9588","discountDownload":"7ee0414f","discountLogin":"7ef99c10","giftActiveRules":"1452a682","giftBag":"95c5f9ff","giftDownload":"02a30d22","guessDifferent-view":"a91ae6c4","guessDifferentHomePage-view":"e12eb60c","guessDifferentLevel-view":"4f2f86b1","guessDifferentMuseum-view":"bf188496","h":"827a7ecc","julydraw":"ba2c81f8","midActiveRules":"0ec7242f","midFestival":"bd3819c7","productList":"c48e79cb","shuiyihecheng":"833b690c","vote":"42a27fd2","yellowposter":"93744c47"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activeDeploy~circleprize~flower~museum~shuiyi~springfes":1,"activeDeploy":1,"springfes":1,"circleprize":1,"flower":1,"museum":1,"shuiyi":1,"ancientOffer":1,"arithmetic":1,"xuejinghanlintu":1,"guessDifferentDetail-view":1,"youcai":1,"beer-announce":1,"canvastest":1,"chinajoyticket":1,"collectCards~share":1,"collectCards":1,"share":1,"demo":1,"discountActiveRules":1,"discountDownload":1,"discountLogin":1,"giftActiveRules":1,"giftBag":1,"giftDownload":1,"guessDifferent-view":1,"guessDifferentHomePage-view":1,"guessDifferentLevel-view":1,"guessDifferentMuseum-view":1,"julydraw":1,"midActiveRules":1,"midFestival":1,"productList":1,"shuiyihecheng":1,"vote":1,"yellowposter":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activeDeploy~circleprize~flower~museum~shuiyi~springfes":"activeDeploy~circleprize~flower~museum~shuiyi~springfes","activeDeploy":"activeDeploy","ancientOffer~arithmetic~circleprize~flower~guessDifferentDetail-view~museum~shuiyi~springfes~xuejing~3bafbee7":"ancientOffer~arithmetic~circleprize~flower~guessDifferentDetail-view~museum~shuiyi~springfes~xuejing~3bafbee7","arithmetic~springfes":"arithmetic~springfes","springfes":"springfes","circleprize":"circleprize","flower":"flower","museum":"museum","shuiyi":"shuiyi","ancientOffer":"ancientOffer","arithmetic":"arithmetic","demo~xuejinghanlintu":"demo~xuejinghanlintu","xuejinghanlintu":"xuejinghanlintu","guessDifferentDetail-view":"guessDifferentDetail-view","guessDifferentLevel-view~youcai":"guessDifferentLevel-view~youcai","youcai":"youcai","beer-announce":"beer-announce","canvastest":"canvastest","chinajoyticket":"chinajoyticket","collectCards~share":"collectCards~share","collectCards":"collectCards","share":"share","demo":"demo","discountActiveRules":"discountActiveRules","discountDownload":"discountDownload","discountLogin":"discountLogin","giftActiveRules":"giftActiveRules","giftBag":"giftBag","giftDownload":"giftDownload","guessDifferent-view":"guessDifferent-view","guessDifferentHomePage-view":"guessDifferentHomePage-view","guessDifferentLevel-view":"guessDifferentLevel-view","guessDifferentMuseum-view":"guessDifferentMuseum-view","h":"h","julydraw":"julydraw","midActiveRules":"midActiveRules","midFestival":"midFestival","productList":"productList","shuiyihecheng":"shuiyihecheng","vote":"vote","yellowposter":"yellowposter"}[chunkId]||chunkId) + "." + {"activeDeploy~circleprize~flower~museum~shuiyi~springfes":"0dafae59","activeDeploy":"57b3ee3d","ancientOffer~arithmetic~circleprize~flower~guessDifferentDetail-view~museum~shuiyi~springfes~xuejing~3bafbee7":"31d6cfe0","arithmetic~springfes":"31d6cfe0","springfes":"bfe4d84f","circleprize":"e7f96f76","flower":"034c936b","museum":"622587d6","shuiyi":"6f28a7bd","ancientOffer":"8e3729fb","arithmetic":"017c7023","demo~xuejinghanlintu":"31d6cfe0","xuejinghanlintu":"651218d0","guessDifferentDetail-view":"a262513f","guessDifferentLevel-view~youcai":"31d6cfe0","youcai":"86870a0a","beer-announce":"81ae9361","canvastest":"2a149c2d","chinajoyticket":"4f6f2df6","collectCards~share":"5625fddf","collectCards":"dbdca4dd","share":"7fe78e53","demo":"9b48c96a","discountActiveRules":"0ea329e9","discountDownload":"8485f0ff","discountLogin":"8012d7c0","giftActiveRules":"a961c479","giftBag":"48f6f147","giftDownload":"b92ff98a","guessDifferent-view":"9d8df446","guessDifferentHomePage-view":"c7a29616","guessDifferentLevel-view":"2407c7aa","guessDifferentMuseum-view":"22ffde5e","h":"31d6cfe0","julydraw":"43238828","midActiveRules":"5fde18c4","midFestival":"fa29478c","productList":"60a54fb4","shuiyihecheng":"bc187fe8","vote":"4ded22d0","yellowposter":"eb44bf54"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
